import { CoreListItem, CoreSingleItem } from "../Misc/List/CoreListItem";
import { SinglePreCacheItem } from "../pre-caching/pre-cache-item";

export class VideoSegmentItem extends CoreListItem<SingleVideoSegmentItem> {
    public get title(): string {
        throw new Error('title must be implemented');
    }
    _isExpanded?: boolean = false; //used by core
}

export class SingleVideoSegmentItem extends SinglePreCacheItem {
}